import React from 'react';
import ReactDOMServer from 'react-dom/server';
import _ from 'lodash';

const calcPercent = (num, total) => (num * 100) / total;

const PeriodSunburstTooltip = (
  parentValue,
  parentName,
  { id, node, parent, value, name, series },
  data,
  single
) => {
  const isNotFirstLevel = node.sliced === undefined && node.level !== 1;

  // проверяем, есть ли у ивента compare with period
  const isEventHasAdditionalPeriod = isNotFirstLevel
    ? data.filter((item) => item.id[0] === parent[0]).length > 1
    : data.filter((item) => item.id[0] === id[0]).length > 1;

  if (!single && !isEventHasAdditionalPeriod) {
    return ReactDOMServer.renderToStaticMarkup(
      <div>
        <span className="tooltip-bold">{name}</span>
        <br />
        Value: <span className="tooltip-bold">{_.round(value, 2)}</span>
        {node.sliced === undefined && node.level !== 1 ? (
          <>
            <br />
            is <span className="tooltip-bold">{_.round(calcPercent(value, parentValue), 2)}% </span>
            <br />
            of {parentName} of: <span className="tooltip-bold">{_.round(parentValue, 2)}</span>
          </>
        ) : undefined}
      </div>
    );
  }

  let splitInfo = ``;
  let period = ``;

  if (node.level >= 3) {
    const parentItem = series.data.find((item) => item.id === parent);
    const rootItem = series.data.find((item) => item.id === parentItem.parent);
    const selectedData = data.find((item) => item.id === rootItem.id);

    splitInfo = `${rootItem.id}.${rootItem.name}.${parentItem.name}`;
    period = selectedData ? selectedData.periods : '';
  } else {
    // находим период для отображения в заголовке тултипа
    const selectedData = isNotFirstLevel
      ? data.find((item) => item.id === parent)
      : data.find((item) => item.id === id);
    period = selectedData ? selectedData.periods : '';
  }

  switch (node.level) {
    case 1:
      return ReactDOMServer.renderToStaticMarkup(
        <div>
          <span className="tooltip-bold">{`${id}.${name} (${period})`}</span>
          <br />
          Value: <span className="tooltip-bold">{_.round(value, 2)}</span>
        </div>
      );

    case 2:
      return ReactDOMServer.renderToStaticMarkup(
        <div>
          <span className="tooltip-bold">{name}</span>
          <br />
          <span className="tooltip-bold">{`${parent}.${parentName} (${period})`}</span>
          <br />
          Value: <span className="tooltip-bold">{_.round(value, 2)}</span>
          <br />
          is <span className="tooltip-bold">{_.round(calcPercent(value, parentValue), 2)}% </span>
          <br />
          of {`${parent}.${parentName}`} of:{' '}
          <span className="tooltip-bold">{_.round(parentValue, 2)}</span>
        </div>
      );

    default:
      return ReactDOMServer.renderToStaticMarkup(
        <div>
          <span className="tooltip-bold">{name}</span>
          <br />
          <span className="tooltip-bold">{`${splitInfo} (${period})`}</span>
          <br />
          Value: <span className="tooltip-bold">{_.round(value, 2)}</span>
          <br />
          is <span className="tooltip-bold">{_.round(calcPercent(value, parentValue), 2)}% </span>
          <br />
          of {`${splitInfo}`} of: <span className="tooltip-bold">{_.round(parentValue, 2)}</span>
        </div>
      );
  }
};

export default PeriodSunburstTooltip;
